import * as React from 'react';
import { Add } from '@mui/icons-material';
import { Button } from 'components';
import { ORDERS_GET_LIST_MOCK } from 'store/orders/orders.mock';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { OrderCard } from './components/OrderCard/OrderCard';
import { OrderCreate } from './components/OrderCreate/OrderCreate';
import { OrderDetail } from './components/OrderDetail/OrderDetail';
import { OrderEdit } from './components/OrderEdit/OrderEdit';
import { TOrders } from './Orders.types';
import './Orders.styled.scss';
import '../../AdminPanel.styles.scss';

type TOrdersView = 'list' | 'detail' | 'create' | 'edit';

export const Orders: TOrders = () => {
  const localize = useLocalize();
  const items = ORDERS_GET_LIST_MOCK.items;
  const [view, setView] = React.useState<TOrdersView>('list');
  const [selectedOrderId, setSelectedOrderId] = React.useState<string | null>(
    null
  );

  const selectedOrder = React.useMemo(
    () => items.find((o) => o.id === selectedOrderId) ?? null,
    [items, selectedOrderId]
  );

  const openDetail = React.useCallback((orderId: string) => {
    setSelectedOrderId(orderId);
    setView('detail');
  }, []);

  const backToList = React.useCallback(() => {
    setSelectedOrderId(null);
    setView('list');
  }, []);

  if (view === 'create') {
    return (
      <div className="admin-orders admin-entity">
        <OrderCreate onBack={backToList} />
      </div>
    );
  }

  if (view === 'edit' && selectedOrder) {
    return (
      <div className="admin-orders admin-entity">
        <OrderEdit order={selectedOrder} onBack={() => setView('detail')} />
      </div>
    );
  }

  if (view === 'detail' && selectedOrder) {
    return (
      <div className="admin-orders admin-entity">
        <OrderDetail
          order={selectedOrder}
          onBack={backToList}
          onEdit={() => setView('edit')}
        />
      </div>
    );
  }

  return (
    <div className="admin-orders admin-entity">
      <div className="admin-orders__toolbar">
        <h4 className="admin-orders__title">
          {localize('admin.orders.title')}
        </h4>
        <Button
          variant="contained"
          endIcon={<Add />}
          onClick={() => {
            setSelectedOrderId(null);
            setView('create');
          }}
        >
          {localize('admin.orders.create')}
        </Button>
      </div>

      <div className="admin-orders__list">
        {items.map((order) => (
          <OrderCard
            key={order.id}
            order={order}
            onSelect={() => openDetail(order.id)}
          />
        ))}
      </div>
    </div>
  );
};
